/* Página de producto Mondraker · Pidiendo Pista */
(function(){
  function initGallery(root){
    var stage=root.querySelector('[data-stage]');if(!stage||stage.dataset.ready)return;stage.dataset.ready=1;
    var thumbs=[].slice.call(root.querySelectorAll('[data-go]'));
    function mark(i){thumbs.forEach(function(t,j){t.setAttribute('aria-selected',j===i)})}
    thumbs.forEach(function(t){t.addEventListener('click',function(){
      var i=+t.dataset.go;stage.scrollTo({left:stage.clientWidth*i,behavior:'smooth'});mark(i);
    })});
    var tm;stage.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(function(){mark(Math.round(stage.scrollLeft/stage.clientWidth))},80)});
  }
  function initSizes(root){
    var form=root.querySelector('[data-mdkp-form]');if(!form||form.dataset.ready)return;form.dataset.ready=1;
    var input=form.querySelector('[data-variant-id]'),add=form.querySelector('[data-add]'),addLabel=add?add.textContent.trim():'',
        stock=form.querySelector('[data-stock]'),price=root.querySelector('[data-price]'),sp=root.querySelector('[data-sticky-price]'),
        sizes=[].slice.call(form.querySelectorAll('.mdkp-size'));
    if(add&&add.disabled)addLabel='Añadir al carrito';
    sizes.forEach(function(b){b.addEventListener('click',function(){
      sizes.forEach(function(x){x.setAttribute('aria-checked',x===b)});
      var ok=b.dataset.available==='true';
      input.value=b.dataset.id;
      if(add){add.disabled=!ok;add.textContent=ok?addLabel:'Agotada'}
      if(stock)stock.innerHTML=ok?'<i class="ok"></i>Disponible':'<i></i>Agotada en esta talla. Escríbenos y te avisamos.';
      if(price)price.innerHTML=(b.dataset.compare?'<s>'+b.dataset.compare+'</s>':'')+'<span>'+b.dataset.price+'</span>';
      if(sp)sp.textContent=b.dataset.price;
      if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',b.dataset.id);history.replaceState(null,'',u)}
    })});
  }
  function initSticky(root){
    var bar=root.querySelector('[data-sticky]'),form=root.querySelector('[data-mdkp-form]');
    if(!bar||!form||!('IntersectionObserver' in window)||bar.dataset.ready)return;bar.dataset.ready=1;
    new IntersectionObserver(function(e){bar.hidden=e[0].isIntersecting||e[0].boundingClientRect.top>0}).observe(form);
  }
  function initSpecs(root){
    [].forEach.call(root.querySelectorAll('.mdkp-cs[data-cs]'),function(cs){
      if(cs.dataset.ready)return;cs.dataset.ready=1;
      var body=cs.querySelector('[data-cs-body]'),btn=cs.querySelector('[data-cs-more]'),items=body.querySelectorAll('.mdkp-cs__item');
      var cols=window.matchMedia('(max-width:820px)').matches?1:2,show=cols*3;
      if(!btn||items.length<=show)return;
      var last=items[show-1],h=last.offsetTop+last.offsetHeight+60;
      cs.style.setProperty('--cs-h',h+'px');cs.classList.add('is-collapsed');btn.hidden=false;
      var lbl=btn.querySelector('span');
      btn.addEventListener('click',function(){
        var open=cs.classList.toggle('is-collapsed')===false;
        btn.setAttribute('aria-expanded',open);lbl.textContent=open?lbl.dataset.less:lbl.dataset.more;
        if(!open)cs.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
  }
  function initGeo(root){
    [].forEach.call(root.querySelectorAll('[data-gt]'),function(gt){
      if(gt.dataset.ready)return;gt.dataset.ready=1;
      var unit=gt.querySelector('[data-gt-unit]'),cells=gt.querySelectorAll('td[data-v]'),sel={};
      function deltas(){
        var d={};
        Object.keys(sel).forEach(function(g){(sel[g]||'').split(/\s+/).forEach(function(t){var m=t.match(/^([A-Z])([+-]\d+(?:\.\d+)?)$/);if(m)d[m[1]]=(d[m[1]]||0)+parseFloat(m[2])})});
        return d;
      }
      function num(x){return String(Math.round(x*100)/100)}
      function render(){
        var d=deltas();
        [].forEach.call(cells,function(td){
          var v=td.getAttribute('data-v'),k=td.parentNode.getAttribute('data-k');
          if(d[k])v=v.replace(/-?\d+(?:\.\d+)?/g,function(n){return num(parseFloat(n)+d[k])});
          td.textContent=unit&&unit.checked?v.replace(/(-?\d+(?:\.\d+)?)\s*mm/g,function(m,n){return (parseFloat(n)/25.4).toFixed(1)+'"'}):v;
        });
      }
      if(unit)unit.addEventListener('change',render);
      [].forEach.call(gt.querySelectorAll('[data-gt-opt]'),function(b){
        b.addEventListener('click',function(){
          var g=b.getAttribute('data-gt-opt');sel[g]=b.getAttribute('data-d');
          [].forEach.call(gt.querySelectorAll('[data-gt-opt="'+g+'"]'),function(o){o.setAttribute('aria-pressed',o===b)});
          var l=gt.querySelector('[data-gt-lbl="'+g+'"]');if(l)l.textContent=b.textContent;
          render();
        });
      });
      var body=gt.querySelector('[data-gt-body]'),btn=gt.querySelector('[data-gt-more]');
      if(!body||!btn)return;
      var rows=body.querySelectorAll('tbody tr'),show=8;
      if(rows.length<=show)return;
      var last=rows[show-1],h=last.offsetTop+last.offsetHeight+40;
      gt.style.setProperty('--gt-h',h+'px');gt.classList.add('is-collapsed');btn.hidden=false;
      var lbl=btn.querySelector('span');
      btn.addEventListener('click',function(){
        var open=gt.classList.toggle('is-collapsed')===false;
        btn.setAttribute('aria-expanded',open);lbl.textContent=open?lbl.dataset.less:lbl.dataset.more;
      });
    });
  }
  var sgLast;
  function sgOpen(trigger){
    var d=document.querySelector('[data-sg]');if(!d)return false;
    if(d.parentNode!==document.body)document.body.appendChild(d);
    sgLast=trigger;d.hidden=false;document.documentElement.classList.add('mdkp-lock');
    var x=d.querySelector('.mdkp-drawer__x');if(x)x.focus();return true;
  }
  function sgClose(){
    var d=document.querySelector('[data-sg]');if(!d||d.hidden)return;
    d.hidden=true;document.documentElement.classList.remove('mdkp-lock');if(sgLast)sgLast.focus();
  }
  document.addEventListener('click',function(e){
    var o=e.target.closest&&e.target.closest('[data-sg-open]');
    if(o){if(sgOpen(o))e.preventDefault();return}
    if(e.target.closest&&e.target.closest('[data-sg-close]'))sgClose();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')sgClose()});
  document.addEventListener('click',function(e){
    var bar=e.target.closest&&e.target.closest('a[href$="#test-ride"]');
    if(bar){var bd=document.querySelector('dialog[data-td]');if(bd&&bd.showModal){e.preventDefault();bd.showModal();var bf=bd.querySelector('input');if(bf)bf.focus()}return}
    var o=e.target.closest&&e.target.closest('[data-td-open]');
    if(o){var d=o.parentNode.querySelector('[data-td]');if(d&&d.showModal){d.showModal();var f=d.querySelector('input');if(f)f.focus()}return}
    var c=e.target.closest&&e.target.closest('[data-td-close]');
    if(c){c.closest('dialog').close();return}
    if(e.target.matches&&e.target.matches('dialog[data-td]'))e.target.close();
  });
  document.addEventListener('click',function(e){
    var o=e.target.closest&&e.target.closest('[data-order-open]');if(!o)return;
    var d=document.querySelector('[data-order]');if(!d||!d.showModal)return;
    var sz=document.querySelector('.mdkp-size[aria-checked="true"]'),si=d.querySelector('[data-order-size]'),pi=d.querySelector('[data-order-price]');
    if(sz&&si)si.value=sz.textContent.trim();
    if(si&&pi&&si.selectedOptions&&si.selectedOptions[0])pi.value=si.selectedOptions[0].dataset.price||pi.value;
    d.showModal();var f=d.querySelector('input:not([type=hidden])');if(f)f.focus();
  });
  document.addEventListener('change',function(e){
    var si=e.target;if(!si.matches||!si.matches('select[data-order-size]'))return;
    var pi=si.form&&si.form.querySelector('[data-order-price]'),o=si.selectedOptions[0];
    if(pi&&o&&o.dataset.price)pi.value=o.dataset.price;
  });
  document.addEventListener('DOMContentLoaded',function(){
    var d=document.querySelector('[data-order][data-open-now]');if(d&&d.showModal)d.showModal();
    var a=document.querySelector('[data-order-wa]'),m=null;if(!a)return;
    try{m=sessionStorage.getItem('mdkpOrderWa');sessionStorage.removeItem('mdkpOrderWa')}catch(err){}
    if(!m)return;
    a.href='https://wa.me/'+a.dataset.wa+'?text='+encodeURIComponent(m);
    setTimeout(function(){location.href=a.href},1200);
  });
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches||!f.matches('[data-order-form]'))return;
    var g=function(n){var x=f.elements['contact['+n+']'];return x?(x.value||'').trim():''};
    var msg='Hola Pidiendo Pista, quiero solicitar un pedido.\n\n'+
      'Bicicleta: '+g('Bicicleta')+'\n'+(g('Talla')?'Talla: '+g('Talla')+'\n':'')+'Precio: $'+g('Precio')+'\n\n'+
      'Nombre: '+g('name')+'\nTeléfono: '+g('phone')+'\nEmail: '+g('email')+'\nCiudad: '+g('Ciudad')+'\nCédula: '+g('Cédula')+
      (g('body')?'\nComentarios: '+g('body'):'')+'\n\n'+g('Enlace');
    var link='https://wa.me/'+(f.getAttribute('data-wa')||'')+'?text='+encodeURIComponent(msg);
    if(!window.fetch||!window.FormData){try{sessionStorage.setItem('mdkpOrderWa',msg)}catch(err){}return}
    e.preventDefault();
    var btn=f.querySelector('button[type=submit]');if(btn){btn.disabled=true;btn.textContent='Enviando...'}
    var box=f.querySelector('.mdkp-td__f'),d=f.querySelector('dialog');
    function done(){
      if(box)box.innerHTML='<button type="button" class="mdkp-td__x" data-td-close aria-label="Cerrar"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>'+
        '<p class="mdkp-td__k">'+g('Bicicleta').replace(/</g,'&lt;')+'</p><h2 class="mdkp-td__t">'+(f.getAttribute('data-ok-title')||'Solicitud recibida')+'</h2>'+
        '<p class="mdkp-td__i">'+(f.getAttribute('data-ok-text')||'')+'</p><a class="mdk-btn mdkp-wa" href="'+link.replace(/"/g,'&quot;')+'">Continuar en WhatsApp</a>';
      if(d&&!d.open&&d.showModal)d.showModal();
      setTimeout(function(){location.href=link},700);
    }
    fetch(f.action,{method:'POST',body:new FormData(f),credentials:'same-origin'}).then(function(r){
      if(/challenge/.test(r.url)){try{sessionStorage.setItem('mdkpOrderWa',msg)}catch(err){}f.submit();return}
      done();
    }).catch(done);
  });
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches||!f.matches('[data-td-form]'))return;
    e.preventDefault();
    var v=function(n){return (f.elements[n].value||'').trim()};
    var sz=document.querySelector('.mdkp-size[aria-checked="true"]');
    var msg='Hola Pidiendo Pista, quiero agendar un test ride de la '+f.dataset.product+(sz?' (talla '+sz.textContent.trim()+')':'')+'.\n\n'+
      'Nombre: '+v('nombre')+'\nTeléfono: '+v('telefono')+'\nEmail: '+v('email')+'\nCiudad: '+v('ciudad')+'\nCédula: '+v('cedula')+'\nEstatura: '+v('estatura')+' cm\n\n'+f.dataset.url;
    window.open('https://wa.me/'+f.dataset.wa+'?text='+encodeURIComponent(msg),'_blank','noopener');
    f.closest('dialog').close();
  });
  function init(root){root=root||document;initSpecs(root);initGeo(root);[].forEach.call(root.querySelectorAll('[data-mdkp]'),function(r){initGallery(r);initSizes(r);initSticky(r)})}
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
